const GOOGLE_MAPS_SCRIPT_ID = "google-maps-places-api";

let googleMapsPlacesPromise: Promise<void> | null = null;

const buildGoogleMapsSrc = (apiKey: string) =>
  `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&v=weekly`;

export const loadGoogleMapsPlacesApi = (apiKey: string): Promise<void> => {
  if (!apiKey) {
    return Promise.resolve();
  }

  if (window.google?.maps?.places) {
    return Promise.resolve();
  }

  if (googleMapsPlacesPromise) {
    return googleMapsPlacesPromise;
  }

  googleMapsPlacesPromise = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(
      GOOGLE_MAPS_SCRIPT_ID
    ) as HTMLScriptElement | null;

    const handleLoad = () => resolve();
    const handleError = () =>
      reject(new Error("Failed to load Google Maps Places API"));

    if (existingScript) {
      existingScript.addEventListener("load", handleLoad, { once: true });
      existingScript.addEventListener("error", handleError, { once: true });
      return;
    }

    const script = document.createElement("script");
    script.id = GOOGLE_MAPS_SCRIPT_ID;
    script.type = "text/javascript";
    script.async = true;
    script.defer = true;
    script.src = buildGoogleMapsSrc(apiKey);
    script.addEventListener("load", handleLoad, { once: true });
    script.addEventListener("error", handleError, { once: true });
    document.head.appendChild(script);
  }).catch((error) => {
    googleMapsPlacesPromise = null;
    throw error;
  });

  return googleMapsPlacesPromise;
};
